module.exports = __webpack_public_path__ + "static/media/pool-img1.576adac6.svg";